import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { MoveBreakoutParticipantDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const moveParticipantToBreakoutSession = async ({
  sessionId,
  body,
}: {
  sessionId: string;
  body: MoveBreakoutParticipantDto;
}): Promise<void> => {
  await axiosClient.post(
    `/sessions/${sessionId}/in-call/move-breakout-participant`,
    body,
  );
};

function useMoveParticipantToBreakoutSession(
  mutationOptions?: Partial<
    UseMutationOptions<
      void,
      HttpError,
      { sessionId: string; body: MoveBreakoutParticipantDto }
    >
  >,
) {
  return useMutation({
    mutationFn: ({ sessionId, body }) =>
      moveParticipantToBreakoutSession({ sessionId, body }),
    ...mutationOptions,
  });
}

export { useMoveParticipantToBreakoutSession };
